<template>
  <!--    data-area-start-->
  <div class="data-area" style="background-image: url(assets/img/data-bg.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="data-cntaint">
            <div class="data-logo">
              <a href="#"><img src="assets/img/data-logo.png" alt=""/></a>
            </div>
            <div class="data-title">
              <h3>{{ article.title }}</h3>
              <p>
                {{ article.subTitle }}
              </p>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6">
                <div class="single-data">
                  <a href="#"><img src="assets/img/d1.png" alt=""/></a>
                  <p v-html="article.text"></p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="single-data">
                  <a href="#"><img src="assets/img/d1.png" alt=""/></a>
                  <p v-html="article.textBox"></p>
                </div>
              </div>
            </div>
            <!-- <div class="data-btn">
              <a href="https://heep.emerging-data.com" class="theme-btn" target="_new"
                >Learn more</a
              >
            </div> -->
            <div class="data-info">
              <p>
                <i class="fas fa-info-circle"></i>Emerging Data is the
                <span>designer and producer of HEEP</span>, the Higher Education Evaluation
                Platform.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 order-first order-lg-last">
          <div class="dtat-img">
            <img src="assets/img/data-img.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    data-area-end-->
</template>

<script>
import { getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';
// TODO: Put in Strapi

export default {
  created() {
    let id = '5fb501ee4939016cbf4a32f1';
    getArticleById(id).then(res => {
      this.article = translate(res);
    });
  },
  data() {
    return {
      article: {}
    };
  }
};
</script>

<style lang="scss" scoped></style>
